/**
 * NOTE: 軽くするため、スタイルはSharp, 可変軸は以下のもののみ読み込んでいる.
 * font-variation-settings:
 * 'FILL' 0,
 * 'wght' 100,
 * 'GRAD' 0,
 * 'opsz' 24
 * https://fonts.google.com/icons?selected=Material+Symbols+Sharp:local_taxi:FILL@0;wght@100;GRAD@0;opsz@24&icon.size=24&icon.color=%235f6368&icon.style=Sharp&icon.query=taxi
 */
export const ICON_FONT_URL = 'https://fonts.googleapis.com/css2?family=Material+Symbols+Sharp:opsz,wght,FILL,GRAD@24,100,0,0';
